import React from "react";

const Icon = ({ icon, selectedLocale }) => {
  return (
    <div style={selectedLocale ? { transform: "scaleX(-1)" } : {}}>{icon}</div>
  );
};

export default Icon;
